// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('p2ReportDefs', {
//         templateUrl: 'views/components/views/p2ReportDefs/p2ReportDefs.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['stateService', 'utilityService', 'p2ReportDefsService', 'printService', 'rememberService', 'ttGridFactory', 'layoutService', function (stateService, utilityService, p2ReportDefsService, printService, rememberService, ttGridFactory, layoutService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let onDestroy = [];

//             let variableNames = {
//                 filtervalue_reports: ''
//             };

//             vm.model = {
//                 tabletSize: layoutService.getMediaQueries().tablet,
//                 gridReportsReady: false,
//                 bgReportDefinitions: {
//                     selected: 'REPORT',
//                     buttons: [
//                         { id: 'REPORT', label: 'p2_reportdefs_reports', color: 'primary', onClick: () => vm.model.bgReportDefinitions.selected = 'REPORT' },
//                         { id: 'PRINTER', label: 'p2_reportdefs_printers', color: 'primary', onClick: () => vm.model.bgReportDefinitions.selected = 'PRINTER' },
//                         { id: 'PRINTERLOCATION', label: 'p2_reportdefs_printerlocation', color: 'primary', onClick: () => vm.model.bgReportDefinitions.selected = 'PRINTERLOCATION' },
//                         { id: 'PRINTCLIENT', label: 'p2_reportdefs_printclient', color: 'primary', onClick: () => vm.model.bgReportDefinitions.selected = 'PRINTCLIENT' }
//                     ]
//                 },
//                 filterValueReportsButtons: [
//                     { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('filtervalue_reports') }
//                 ],
//                 setting: {},
//                 itemsListReports: [],
//                 itemsListPrinters: [],
//                 itemsListClients: [],
//                 updatingChanges: false,
//                 printerLocationGrid: false,
//                 printersGrid: false
//             };

//             vm.gridReports = new ttGridFactory({
//                 rememberId: 'p2reportdef_list_grid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             }).setCustomToolbarButtons([{
//                 name: 'p2reportdefs_new',
//                 text: 'p2reportdefs_new',
//                 func: () => stateService.go('p2reportdef', { p2_reportdef_keyno: '0' }),
//                 icon: 'fa-plus',
//                 cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                 translate: true
//             }]);
            
//             vm.printersGrid = new ttGridFactory({
//                 rememberId: 'w_p2reportdefs.printersgrid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             }).setLoadDataFunction({
//                 method: 3594,
//                 parameters: {}
//             }).setSaveDataFunction({
//                 method: null,
//                 parameters: {},
//                 autoSave: true,
//                 confirm: null
//             });

//             vm.printerLocationGrid = new ttGridFactory({
//                 rememberId: 'w_p2reportdefs.printerlocationgrid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             }).setLoadDataFunction({
//                 method: 3593,
//                 parameters: {}
//             }).setAddRowFunction({
//                 method: null,
//                 parameters: {},
//                 pre: null,
//                 post: null,
//                 autoSave: true,
//                 confirm: null
//             }).setSaveDataFunction({
//                 method: null,
//                 parameters: {},
//                 autoSave: true,
//                 confirm: null
//             }).setRemoveRowFunction({
//                 method: null,
//                 parameters: {},
//                 autoSave: true,
//                 confirm: null,
//                 post: null
//             }).setSpecialFunc({
//                 buttons: [
//                     {
//                         name: 'customDelete',
//                         text: '',
//                         icon: 'far-trash-alt',
//                         type: 'danger',
//                         func: async function (data) {
//                             await vm.printerLocationGrid.gridfunc.removeRow(data);
//                             vm.printerLocationGrid.gridfunc.saveChanges(false);
//                             vm.printersGrid.gridfunc.read();
//                         }
//                     }
//                 ]
//             });

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE CALL
            
//             async function loadSetting() {
//                 vm.model.setting = (await p2ReportDefsService.getSetting())[0];
//     		}
            
//             async function loadReports() {
//                 vm.model.itemsListReports = [];

//                 const list = await p2ReportDefsService.listReports();

//                 vm.model.updatingChanges = false;
//                 vm.model.itemsListReports = list;
//             }
            
//             async function loadPrinters() {
//                 const list = await p2ReportDefsService.listPrinters();

//                 vm.model.updatingChanges = false;
//                 vm.model.itemsListPrinters = list;
//             }
            
//             async function loadClients() {
//                 vm.model.itemsListClients = [];

//                 const list = await p2ReportDefsService.listClients();

//                 vm.model.updatingChanges = false;
//                 vm.model.itemsListClients = list;
//             }

//             // #endregion LOAD PROCEDURE CALL

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGridReports() {
//                 vm.gridReports.dataTask.loadData = {
//                     method: 3735,
//                     parameters: {}
//                 };

//                 vm.model.updatingChanges = false;
//                 vm.model.gridReportsReady = true;

//                 if (vm.gridReports.gridfunc !== null) vm.gridReports.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             function rememberFunc(id) {
//                 Object.keys(variableNames).forEach((key) => {
//                     variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                 });

//                 if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                 let variableValue = null;

//                 switch (id) {
//                     case 'filtervalue_reports':
//                         if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                         variableValue = vm.model.setting[id];
//                         break;
//                     default:
//                         break;
//                 }

//                 return rememberService.remember(variableNames[id], variableValue);
//             }

//             // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//             // #region RESET BUTTON FUNCTION

//             function clear(id) {
//                 switch (id) {
//                     case 'filtervalue_reports':
//                         vm.model.setting.filtervalue_reports = '';

//                         if (vm.model.setting.filtervalue_reports === '') rememberFunc('filtervalue_reports');
//                         break;
//                     default:
//                         break;
//                 }
//             }

//             // #endregion RESET BUTTON FUNCTION

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'filtervalue_reports':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.filtervalue_reports) !== true) return;

//                         vm.model.setting.filtervalue_reports = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.filtervalue_reports, true) !== true) return;

//                         if (vm.model.setting.filtervalue_reports === '') rememberFunc('filtervalue_reports');
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON BLUR MULTI FUNCTIONS

//             vm.onBlur = function (id) {
//                 switch (id) {
//                     case 'filtervalue_reports':
//                         if (utilityService.validateParmsValue(vm.model.setting.filtervalue_reports) !== true) return;

//                         if (vm.model.setting.filtervalue_reports > '') rememberFunc('filtervalue_reports');
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion ON BLUR MULTI FUNCTIONS

//             // #region BUTTON UPDATE PROCEDURES
    
//             vm.updateChanges = function () {
//                 vm.model.updatingChanges = true;

//                 printService.getReports().then(function (data) {
//                     p2ReportDefsService.updateReports(data).then(function () {
//                         loadReports();
//                         loadGridReports();
//                     });
//                 });
                
//                 printService.getPrinters().then(function (data) {
//                     p2ReportDefsService.updatePrinters(data)
//                     /*
//                     .then(function () {
//                     //    loadPrinters();
//                     });
//                     */
//                 });
                
//                 printService.getClients().then(function (data) {
//                     p2ReportDefsService.updateClients(data).then(function () {
//                         loadClients();
//                     });
//                 });
                
//                 //printService.getParameters({ reportKeyno: 1 }).then(function (data) {
//                 //    //console.log('params');
//                 //    //console.dir(data);
//                 //    //console.log(angular.toJson(data));
//                 //});
//             };

//             // #endregion BUTTON UPDATE PROCEDURES

//             // #region BUTTON GROUP SINGLE FUNCTION

//             vm.selectBgReportDefinitions = function (value) {
//                 vm.model.bgReportDefinitions.selected = value;
//             };

//             // #endregion BUTTON GROUP SINGLE FUNCTION

//             // #region MULTI DIRECTION BUTTON FUNCTIONS

//             vm.goToFunc = function (state, e) {
//                 function go(parms) {
//                     if (e?.ctrlKey) {
//                         stateService.newTab(state, parms);
//                     } else {
//                         stateService.go(state, parms);
//                     }
//                 }

//                 switch (state) {
//                     case 'p2reportdef':
//                         go({ p2_reportdef_keyno: '0' });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//             // #region ON WINDOW RESIZE FUNCTION

//             async function onWindowResize() {
//                 if (vm.model.tabletSize.matches === true) {
//                     loadGridReports();
//                     vm.model.printersGrid = true;
//                 } else {
//                     loadReports();
//                     loadPrinters();
//                 }
//             }

//             // #endregion ON WINDOW RESIZE FUNCTION

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 loadSetting();
//                 loadClients();

//                 vm.model.printerLocationGrid = true;

//             	window.addEventListener('resize', onWindowResize);
//             	onWindowResize();
//             };

//             // #endregion ON INIT FUNCTION

//             // #region DESTROY FUNCTION

//             vm.$onDestroy = function () {
//             	window.removeEventListener('resize', onWindowResize);

//             	onDestroy.forEach((fn) => {
//             		if (typeof fn === 'function') fn();
//             	});
//             };

//             // #endregion DESTROY FUNCTION

//         }]
//     });
// })();
